module.exports = __webpack_public_path__ + "img/DK65746018.46f45c87.png";